module.exports = {
  "/": {
    "name": "root-redirect"
  },
  "/preload": {
    "name": "embed-preload",
    "success": {
      "embed preload": [
        "EMBED_PRELOAD"
      ]
    }
  },
  "/website": {
    "name": "storefront-home",
    "success": {
      "storefront home loaded": [
        "STOREFRONT_HOME_LOAD"
      ],
      "themes loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/website/page/:pageNumber": {
    "name": "storefront-home-page",
    "success": {
      "themes loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/website/categories": {
    "name": "all-categories",
    "success": {
      "all categories loaded": [
        "THEMES_ALL_BUSINESS_TYPES_LOAD"
      ]
    }
  },
  "/website/all": {
    "name": "all-storefront",
    "success": {
      "themes loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/website/themes/_preview/:offeringId": {
    "name": "theme-details-provider-preview",
    "success": {
      "theme details loaded": [
        "THEME_DETAILS_LOAD"
      ],
      "theme details preview forbidden error": [
        "THEME_DETAILS_FORBIDDEN_ERROR_LOAD"
      ]
    },
    "partialSuccess": {
      "theme details error": [
        "THEME_DETAILS_ERROR_LOAD"
      ]
    }
  },
  "/website/themes/all-business-types": {
    "name": "themes-all-business-types-redirect"
  },
  "/website/themes/:slug": {
    "name": "theme-details-redirect"
  },
  "/website/themes/:slug/write-review": {
    "name": "theme-write-review-redirect"
  },
  "/website/:slugOrCategory": {
    "name": "theme-details-or-category",
    "success": {
      "theme details loaded": [
        "THEME_DETAILS_LOAD"
      ],
      "themes loaded": [
        "ASSETS_LOAD"
      ],
      "theme details error": [
        "THEME_DETAILS_ERROR_LOAD"
      ]
    }
  },
  "/website/:slug/write-review": {
    "name": "theme-write-review",
    "success": {
      "theme review loaded": [
        "REVIEW_WIZARD_LOAD"
      ],
      "theme details 404": [
        "THEME_DETAILS_404_LOAD"
      ]
    }
  },
  "/website/:category/page/:pageNumber": {
    "name": "storefront-category-page",
    "success": {
      "themes loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/website/:category/:subcategory": {
    "name": "storefront-category-subcategory",
    "success": {
      "themes loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/website/:category/:subcategory/page/:pageNumber": {
    "name": "storefront-category-subcategory-page",
    "success": {
      "themes loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/modules": {
    "name": "modules-home",
    "success": {
      "modules loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/modules/page/:pageNumber": {
    "name": "all-modules-storefront-page",
    "success": {
      "modules loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/modules/:slugOrCategory/page/:pageNumber": {
    "name": "modules-storefront-category-page",
    "success": {
      "modules loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/modules/:slugOrCategory": {
    "name": "module-details-or-category",
    "success": {
      "module details loaded": [
        "MODULE_DETAILS_LOAD"
      ],
      "modules loaded": [
        "ASSETS_LOAD"
      ],
      "module details error": [
        "MODULE_DETAILS_ERROR_LOAD"
      ]
    }
  },
  "/modules/:slug/write-review": {
    "name": "module-write-review",
    "success": {
      "module review loaded": [
        "REVIEW_WIZARD_LOAD"
      ],
      "module details 404": [
        "MODULE_DETAILS_404_LOAD"
      ]
    }
  },
  "/modules/_preview/:offeringId": {
    "name": "module-details-provider-preview",
    "success": {
      "module details loaded": [
        "MODULE_DETAILS_LOAD"
      ],
      "module details preview forbidden error": [
        "MODULE_DETAILS_FORBIDDEN_ERROR_LOAD"
      ]
    },
    "error": [
      "MODULE_DETAILS_ERROR_LOAD"
    ]
  },
  "/templates": {
    "name": "templates-home",
    "success": {
      "templates loaded": [
        "TEMPLATES_LOAD"
      ]
    }
  },
  "/templates/featured": {
    "name": "templates-featured",
    "success": {
      "collections loaded": [
        "FEATURED_THEMES_LOAD"
      ]
    }
  },
  "/templates/search": {
    "name": "templates-search",
    "success": {
      "search results loaded": [
        "ASSETS_LOAD"
      ]
    }
  },
  "/templates/search/page/:pageNumber": {
    "name": "templates-search-page",
    "success": {
      "search results loaded": [
        "ASSETS_LOAD"
      ]
    }
  }
};